/**
 * Semantic version string representing of the minimum compatible version of Contracts to display in output.
 */
export const compatibleContractsSemver = '^5.0.0';
